import type { IconProps } from './IconProps';

export const ExpandIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={props['aria-hidden']}
    aria-label={props['aria-label']}
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8184 9.34957C11.4041 9.34957 11.0684 9.01379 11.0684 8.59957V5.10693H7.57572C7.16151 5.10693 6.82572 4.77115 6.82572 4.35693C6.82572 3.94272 7.1615 3.60693 7.57572 3.60693L11.8184 3.60693C12.2326 3.60693 12.5684 3.94272 12.5684 4.35693V8.59957C12.5684 9.01379 12.2326 9.34957 11.8184 9.34957Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.18164 7.00019C4.59585 7.00019 4.93164 7.33598 4.93164 7.75019V11.2428H8.42428C8.83849 11.2428 9.17428 11.5786 9.17428 11.9928C9.17428 12.407 8.83849 12.7428 8.42428 12.7428H4.18164C3.76743 12.7428 3.43164 12.407 3.43164 11.9928L3.43164 7.75019C3.43164 7.33598 3.76743 7.00019 4.18164 7.00019Z"
      fill="currentColor"
    />
  </svg>
);
